import {WOFSlice} from '@src/Components/SharedConfigProvider';

export interface QuizQuestion {
	id: string;
	question: string;
	correctAnswerId: string;
	answers: {
		id: string;
		value: string;
	}[];
}

const quizQuestionP3: QuizQuestion[] = [
	{
		id: '1',
		question: 'Was bedeutet die Abkürzung ELS?',
		correctAnswerId: '1a',
		answers: [
			{
				id: '1a',
				value: 'Einrohrlüftungssystem',
			},
			{
				id: '1b',
				value: 'Elektrisches Lüftungssystem',
			},
			{
				id: '1c',
				value: 'Einbaulagenstabilisierung',
			},
		],
	},
	{
		id: '2',
		question: 'Was bedeutet die Abkürzung WRL?',
		correctAnswerId: '2a',
		answers: [
			{
				id: '2a',
				value: 'Wohnraumlüftung',
			},
			{
				id: '2b',
				value: 'Wintergarten-Raumlüftungssystem',
			},
			{
				id: '2c',
				value: 'Wind- und Regenschutz-Lüftungsgitter',
			},
		],
	},
	{
		id: '3',
		question:
			'Wie lässt sich ein Dröhngeräusch bei Decken- oder Schachteinbau beheben?',
		correctAnswerId: '3a',
		answers: [
			{
				id: '3a',
				value: 'Gehäuse fest mit der Rohdecke bzw. Außenmauerwerk des Schachtes verbinden',
			},
			{
				id: '3b',
				value: 'Den Lüfter um 180 Grad drehen',
			},
			{
				id: '3c',
				value: 'Anderen Rohrdurchmesser wählen',
			},
		],
	},
	{
		id: '4',
		question:
			'Wie kann bei zu tief eingebautem Gehäuse in einer Rigipswand die korrekte Gebläsemontage und -funktion sichergestellt werden? ',
		correctAnswerId: '4b',
		answers: [
			{
				id: '4a',
				value: 'Montagefedern auf hintere Position einhängen',
			},
			{
				id: '4b',
				value: 'Montagefedern auf vordere Position einhängen',
			},
			{
				id: '4c',
				value: 'gar nicht',
			},
		],
	},
	{
		id: '5',
		question: 'Wo wird idealerweise ein Badlüfter montiert?',
		correctAnswerId: '5a',
		answers: [
			{
				id: '5a',
				value: 'möglichst nahe dort, wo die größte Feuchtigkeit anfällt',
			},
			{
				id: '5b',
				value: 'in der Badezimmertür',
			},
			{
				id: '5c',
				value: 'im Nebenraum',
			},
		],
	},
];

const quizQuestionP2: QuizQuestion[] = [
	{
		id: '1',
		question:
			'Welche Gefahr besteht bei einem zu tief eingebauten Gehäuse in einer Rigipswand?',
		correctAnswerId: '1a',
		answers: [
			{
				id: '1a',
				value: 'Leistungsverlust durch Falschluftansaugung aus Hohlraum',
			},
			{
				id: '1b',
				value: 'Brandgefahr',
			},
			{
				id: '1c',
				value: 'Kurzschlussgefahr',
			},
		],
	},
	{
		id: '2',
		question:
			'Welche der folgenden Ursachen kann zu einer schlechten Lüfterleistung führen? ',
		correctAnswerId: '2a',
		answers: [
			{
				id: '2a',
				value: 'Der Filter ist stark verschmutzt',
			},
			{
				id: '2b',
				value: ' Die Luft im Raum ist zu feucht',
			},
			{
				id: '2c',
				value: 'Durch Luftdruckabfall vor einer aufziehenden Schlechtwetterzone',
			},
		],
	},
	{
		id: '3',
		question:
			'Worauf lässt ein starkes Dröhngeräusch bei Decken- oder Schachteinbau schließen?',
		correctAnswerId: '3c',
		answers: [
			{
				id: '3a',
				value: 'Der Rohranschluss des verbauten Lüfters ist undicht',
			},
			{
				id: '3b',
				value: 'Der Lüfter ist in der falschen Einbaulage montiert',
			},
			{
				id: '3c',
				value: 'Das Gehäuse oder anschließende Luftrohre sind unzureichend angeschraubt',
			},
		],
	},
];

const quizQuestionP1: QuizQuestion[] = [
	{
		id: '1',
		question:
			'Wann wurde der Limodor CC, das erste Lüftungsgerät von Limodor, gebaut?',
		correctAnswerId: '1b',
		answers: [
			{
				id: '1a',
				value: '1976',
			},
			{
				id: '1b',
				value: '1966',
			},
			{
				id: '1c',
				value: '2001',
			},
		],
	},
];

const questionsMap = {
	[WOFSlice.Prize1]: quizQuestionP1,
	[WOFSlice.Prize2]: quizQuestionP2,
	[WOFSlice.Prize3]: quizQuestionP3,
	[WOFSlice.NoPrize]: [],
};

export const randomQuestionForType = (type: WOFSlice) => {
	const questions = questionsMap[type];
	const index = Math.floor(Math.random() * questions.length);
	return questions[index];
};
